import React from 'react';

// - Add '.fill' to all body classes.
// - Add '.tail' <g> around tail. Remember to add '.fill' to tail shape so that:
	// <g .tail > <path .fill /> </g>

export default function Feet() {
	return (
		<g>
			<path className="fill fill--dark leg leg--rear-back" d="M298.31717,324.67218l-14.13531,43.47711
				c-1.35538,4.53668-4.99026,4.27213-10.46832,4.27213h4.5849c-9.28491,0.32147-14.5705,0.11435-16.24265-4.42099
				c0,0-19.54538-44.77362-16.64923-79.81122L298.31717,324.67218z" />
			<path className="fill leg leg--rear-front" d="M288.43228,326.96466l12.98904,43.47711
				c1.35538,4.53665,4.99026,4.27213,10.46835,4.27213h-4.58493c9.87527,0.00296,14.13843,0.46872,16.24265-4.42099
				c0,0,19.66895-39.45258,22.12881-73.15683C345.8403,294.88788,288.43228,326.96466,288.43228,326.96466z" />
			<path className="fill fill--dark leg leg--front-back" d="M210.40121,324.41797l-8.40413,43.47711
				c-1.35536,4.53668-8.42896,4.27213-13.90704,4.27213h4.58492c-5.54558,0-12.88132,0.27368-13.95016-4.42099
				c0,0-19.54539-44.77362-16.64925-79.81122L210.40121,324.41797z" />
			<path className="fill leg leg--front-front" d="M206.90051,326.97482l11.84283,43.47711
				c1.35536,4.53668,7.28271,4.27213,12.7608,4.27213h-3.43867c5.54558,0,12.88132,0.27365,13.95016-4.42099
				c0,0,19.54539-44.77365,16.64925-79.81125L206.90051,326.97482z" />
		</g>
	);
}



// WEBPACK FOOTER //
// ./src/components/Global/Pet/Pig/Feet.js